import * as React from 'react';

import * as styles from './Page.css';

interface IPageProps {
  children: React.ReactNode;
}

export const Page: React.FC<IPageProps> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
